import { Dialog, DialogContent, Box, Typography, DialogActions, FormHelperText, MenuItem, Select, Button, Grid } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setMachineDetailsData } from '../../../redux/machineDetailsDataSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/machines/modierLocalisationMetier.css';

export const ModifierLocalisationMetier = ({ modifyLocalisationMetier, setModifyLocalisationMetier }) => {

    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const authenticatedUser = useSelector(state => state.AuthenticatedUser);
    const machineDetailsData = useSelector((state) => state.MachineDetailsData);

    const [regions, setRegions] = useState([]);
    const [sites, setSites] = useState([]);
    const [poles, setPoles] = useState([]);
    const [metiers, setMetiers] = useState([]);
    const [selectedMetiers, setSelectedMetiers] = useState(machineDetailsData?.machine_metier?.map(metier => metier?.metier?.id));

    const formik = useFormik({
        initialValues: {
            selectedRegion: machineDetailsData?.region?.id,
            selectedSite: machineDetailsData?.site?.id,
            selectedPole: machineDetailsData?.pole?.id,
        },
        validationSchema: Yup.object().shape({
            selectedRegion: Yup.string().required(t('isRequired')),
            selectedSite: Yup.string().required(t('isRequired')),
            selectedPole: Yup.string().required(t('isRequired')),
        }),
        onSubmit: async (values) => {
            try {
                const data = {
                    region: values.selectedRegion,
                    site: values.selectedSite,
                    pole: values.selectedPole,
                    metiers: selectedMetiers,
                };

                const response = await axios.patch(`machine/localisation_metier/${id}`, data);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setSuccessfullModifyDialog({ open: true, type: 'Modifier la localisation et les métiers' }));
                    dispatch(setMachineDetailsData({ ...machineDetailsData, region: response.data.updateLocalisation.region, pole: response.data.updateLocalisation.pole, site: response.data.updateLocalisation.site, machine_metier: response.data.machine_metiers }));
                    setModifyLocalisationMetier(false);
                }
            } catch (error) {
                console.error('Error update localisation:', error);
                CustomErrorLogger(error, 'Error update localisation_metier in ModifierLocalisationMetier');
            }
        },
    });

    const { handleSubmit, values, handleChange, handleBlur, touched, errors, setFieldValue } = formik;

    const handleChangeMetier = (metier) => {
        setSelectedMetiers(prevSelectedMetiers => {
            if (prevSelectedMetiers.includes(metier.id)) {
                return prevSelectedMetiers.filter(id => id !== metier.id);
            } else {
                return [...prevSelectedMetiers, metier.id];
            }
        });
    };

    const fetchRegions = useCallback(async () => {
        try {
            const response = await axios.get('region');
            if (response.status === 200 || response.status === 201) {
                setRegions(response.data);
            }
        } catch (error) {
            console.error('Error Fetching regions:', error);
            CustomErrorLogger(error, 'Error Fetching regions in ModifierLocalisationMetier');
        }
    }, []);

    const fetchSites = useCallback(async () => {
        if (!values.selectedRegion) return;
        try {
            const response = await axios.get('site', { params: { regions: [values.selectedRegion] } });
            if (response.status === 200 || response.status === 201) {
                setSites(response.data);
            }
        } catch (error) {
            console.error('Error fetching sites:', error);
            CustomErrorLogger(error, 'Error fetching sites in ModifierLocalisationMetier');
        }
    }, [values.selectedRegion]);

    const fetchPoles = useCallback(async () => {
        if (!values.selectedSite) return;
        try {
            const response = await axios.get('pole', { params: { sites: [values.selectedSite] } });
            if (response.status === 200 || response.status === 201) {
                setPoles(response.data);
            }
        } catch (error) {
            console.error('Error fetching poles:', error);
            CustomErrorLogger(error, 'Error fetching poles in ModifierLocalisationMetier');
        }
    }, [values.selectedSite]);

    const fetchMetiers = useCallback(async () => {
        try {
            const response = await axios.get('metier', { params: { poles: [values.selectedPole], sites: [values.selectedSite] } });
            if (response.status === 200 || response.status === 201) {
                setMetiers(response.data);
            }
        } catch (error) {
            console.error('Error Fetching metiers:', error);
            CustomErrorLogger(error, 'Error Fetching metiers in ModifierLocalisationMetier');
        }
    }, [values.selectedPole, values.selectedSite]);

    useEffect(() => {
        fetchRegions()
    }, [fetchRegions]);

    useEffect(() => {
        fetchSites()
    }, [fetchSites, values.selectedRegion]);

    useEffect(() => {
        fetchPoles()
    }, [fetchPoles, values.selectedSite]);

    useEffect(() => {
        fetchMetiers()
    }, [fetchMetiers, values.selectedSite, values.selectedPole]);

    return (
        <Dialog open={modifyLocalisationMetier} fullWidth>
            <Box onClick={() => setModifyLocalisationMetier(false)} className='modifierlocalisationMetier_icon_text'>
                <Typography className='modifierLocalisationMetier_title'>{t('Modifier la localisation et les métiers')}</Typography>
                <Iconify icon={"material-symbols:close"} className='modifierLocalisationMetier_close_icon' />
            </Box>
            <form onSubmit={handleSubmit}>
                <DialogContent className='modifierLocalisationMetier_dialog_content'>
                    {authenticatedUser.user_region_ids.length > 1 &&
                        <Box className='modifierLocalisationMetier_helper_selct_box'>
                            <FormHelperText id="outlined-weight-helper-text" className="modifierLocalisationMetier_helper_text">{t('Region')}</FormHelperText>
                            <Select
                                className={values.selectedRegion ? `modifierLocalisationMetier_select_metier filledField` : `modifierLocalisationMetier_select_metier`}
                                value={values.selectedRegion}
                                onChange={(e) => {
                                    handleChange(e);
                                    setFieldValue('selectedSite', '');
                                    setFieldValue('selectedPole', '');
                                    setSelectedMetiers([]);
                                }}
                                onBlur={handleBlur}
                                options={regions}
                                name="selectedRegion"
                                error={touched.selectedRegion && Boolean(errors.selectedRegion)}
                            >
                                {regions?.map((region) => (
                                    <MenuItem
                                        key={region?.id} className='modifierLocalisationMetier_select_metier_item' value={region?.id}>
                                        {region?.name}
                                    </MenuItem>
                                ))}
                            </Select>
                            {touched.selectedRegion && errors.selectedRegion && (
                                <FormHelperText error className='modifierLocalisationMetier_select_helper'>{errors.selectedRegion}</FormHelperText>
                            )}
                        </Box>
                    }
                    <Box className='modifierLocalisationMetier_helper_selct_box'>
                        <FormHelperText id="outlined-weight-helper-text" className="modifierLocalisationMetier_helper_text">{t('Site')}</FormHelperText>
                        <Select
                            className={values.selectedSite ? `modifierLocalisationMetier_select_metier filledField` : `modifierLocalisationMetier_select_metier`}
                            value={values.selectedSite}
                            onChange={(e) => {
                                handleChange(e);
                                setFieldValue('selectedPole', '');
                                setSelectedMetiers([]);
                            }}
                            onBlur={handleBlur}
                            options={sites}
                            name="selectedSite"
                            error={touched.selectedSite && Boolean(errors.selectedSite)}
                        >
                            {sites?.map((site) => (
                                <MenuItem
                                    key={site.id} className='modifierLocalisationMetier_select_metier_item' value={site.id}>
                                    {site.name}
                                </MenuItem>
                            ))}
                        </Select>
                        {touched.selectedSite && errors.selectedSite && (
                            <FormHelperText error className='modifierLocalisationMetier_select_helper'>{errors.selectedSite}</FormHelperText>
                        )}
                    </Box>
                    <Box className='modifierLocalisationMetier_helper_selct_box'>
                        <FormHelperText id="outlined-weight-helper-text" className="modifierLocalisationMetier_helper_text">{t('Pôle')}</FormHelperText>
                        <Select
                            className={values.selectedPole ? `modifierLocalisationMetier_select_metier filledField` : `modifierLocalisationMetier_select_metier`}
                            value={values.selectedPole}
                            onChange={(e) => {
                                handleChange(e);
                                setSelectedMetiers([]);
                            }}
                            onBlur={handleBlur}
                            options={poles}
                            name="selectedPole"
                            error={touched.selectedPole && Boolean(errors.selectedPole)}
                        >
                            {poles?.map((pole) => (
                                <MenuItem
                                    key={pole.id} className='modifierLocalisationMetier_select_metier_item' value={pole.id}>
                                    {pole.name}
                                </MenuItem>
                            ))}
                        </Select>
                        {touched.selectedPole && errors.selectedPole && (
                            <FormHelperText error className='modifierLocalisationMetier_select_helper'>{errors.selectedPole}</FormHelperText>
                        )}
                    </Box>
                    {metiers?.length > 0 &&
                        <Box className='modifierLocalisationMetier_helper_selct_box'>
                            <FormHelperText id="outlined-weight-helper-text" className="modifierLocalisationMetier_helper_text">{t('Métiers')}</FormHelperText>
                            <Grid container spacing={2}>
                                {metiers && metiers?.map(metier => (
                                    <Grid item xs={12} sm={6} key={metier.id}>
                                        <Box
                                            onClick={() => handleChangeMetier(metier)}
                                            className='modifierLocalisationMetier_check_metier_box'
                                            style={{ borderColor: selectedMetiers?.includes(metier.id) ? '#44CF3B' : '#DEDDDD', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                        >
                                            <Iconify
                                                className='modifierLocalisationMetier_check_icons'
                                                icon={"material-symbols:check"}
                                                style={{
                                                    color: 'white',
                                                    size: '1.5em',
                                                    width: '24px',
                                                    height: '24px',
                                                    backgroundColor: selectedMetiers?.includes(metier.id) ? '#44CF3B' : '#DEDDDD',
                                                    borderRadius: '50%',
                                                    padding: '5px',
                                                }}
                                            />
                                            <Typography
                                                className='modifierLocalisationMetier_check_metier_typography' >{metier.name}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>}
                </DialogContent>
                <DialogActions className='modifierLocalisationMetier_dialog_actions'>
                    <Button className='modifierLocalisationMetier_button_annuler' onClick={() => setModifyLocalisationMetier(false)}>{t('Annuler')}</Button>
                    <Button className='modifierLocalisationMetier_button_valider' variant="contained" type='submit'>{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};